import {faPenToSquare} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex} from 'antd';
import {ReactElement} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {gray7} from '../../../../../../../../css/var-export.scss';
import {CatalogHistoryGroupType} from '../../../../../../../../service/reviews/reviews-history-helper-type';

import {HistoryCatalogEditComment} from './history-catalog-edit-comment';
import {HistoryCatalogEditRating} from './history-catalog-edit-rating';
import {HistoryCatalogEditSection} from './history-catalog-edit-section';

type PropsType = {
    formattedDate: string | null;
    formattedTime: string | null;
    group: CatalogHistoryGroupType;
};

export function HistoryCatalogEditLog(props: PropsType): ReactElement | null {
    const {formattedDate, formattedTime, group} = props;

    const {rating, comment} = group;

    if (!rating && !comment) {
        return null;
    }

    return (
        <Flex gap={8} vertical>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Flex gap={8}>
                <FontAwesomeIcon color={gray7} fontSize={16} icon={faPenToSquare} />
                <Text lighter stringKey="REVIEWS__REVIEW_CHANGE_HISTORY__ON_CATALOG" />
            </Flex>
            <Flex gap={16} vertical>
                <HistoryCatalogEditSection titleStringKey="REVIEWS__REVIEW_CHANGE_HISTORY__BEFORE">
                    {rating && <HistoryCatalogEditRating value={rating.oldValue} />}
                    {comment && <HistoryCatalogEditComment value={comment.oldValue} />}
                </HistoryCatalogEditSection>
                <HistoryCatalogEditSection titleStringKey="REVIEWS__REVIEW_CHANGE_HISTORY__AFTER">
                    {rating && <HistoryCatalogEditRating value={rating.newValue} />}
                    {comment && <HistoryCatalogEditComment value={comment.newValue} />}
                </HistoryCatalogEditSection>
            </Flex>
        </Flex>
    );
}
